import compileSymbols from '~/utils/compileSymbols';
const types = [
  'FETCH_SAVED_DESIGNS_START',
  'FETCH_SAVED_DESIGNS_SUCCESS',
  'FETCH_SAVED_DESIGNS_FAILED',
  'FETCH_PROFILE',
  'FETCH_PROFILE_FAILED',
  'FETCH_VOUCHER',
  'FETCH_VOUCHER_FAILED',
  'LOCATION',
  'LOCATION_LOADED',
  'LOCATION_FAILED',
  'SET_PREFER_SINGLES',
  'SELECT_SAVED_DESIGN_INDEX',
  'UPDATE_INTERNAL_USER',
  'UPDATE_LTV_CUSTOMER',
  'UPDATE_PROFILE',
  'UPDATE_SDFU'
];
export default compileSymbols(types, 'account');
